import { DateBookingRequestCheckoutState, GroupBookingRequestCheckoutState } from '@shared/types';
import { FunctionComponent } from 'react';
import { CheckoutFlowWrapper } from '../../CheckoutFlowWrapper';
import { useBookingRequestCheckoutContext } from '../../CheckoutContext/BookingRequestContext';
import { DatesStep } from './DatesStep';
import { MessageStep } from './MessageStep';
import { ContactDetailsStep } from '../../ContactDetailsStep';
import { ConfirmationStep } from './ConfirmationStep';

export type BookingRequestFlowProps = {};

const unauthenticatedSteps: Array<{
    key: (DateBookingRequestCheckoutState | GroupBookingRequestCheckoutState)['currentStep'];
    label: string;
}> = [
    {
        key: 'dates',
        label: 'Dates',
    },
    {
        key: 'message',
        label: 'Message',
    },
];

const authenticatedSteps: Array<{
    key: (DateBookingRequestCheckoutState | GroupBookingRequestCheckoutState)['currentStep'];
    label: string;
}> = [
    {
        key: 'contactDetails',
        label: 'Contact Info',
    },
    {
        key: 'confirmation',
        label: 'Confirmation',
    },
];

const BookingRequestStep: FunctionComponent<BookingRequestFlowProps> = () => {
    const { checkoutState } = useBookingRequestCheckoutContext();
    switch (checkoutState.currentStep) {
        case 'dates':
            return <DatesStep />;

        case 'message':
            return <MessageStep />;

        case 'contactDetails':
            return <ContactDetailsStep />;

        case 'confirmation':
            return <ConfirmationStep />;
    }
};

export const BookingRequestFlow: FunctionComponent<BookingRequestFlowProps> = () => {
    return (
        <CheckoutFlowWrapper
            authenticatedSteps={authenticatedSteps}
            unauthenticatedSteps={unauthenticatedSteps}
        >
            <BookingRequestStep />
        </CheckoutFlowWrapper>
    );
};
